var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutoFitContainer',[_c('div',{staticClass:"user-page"},[_c(_vm.currentComponent,{tag:"component",scopedSlots:_vm._u([{key:"operation",fn:function(){return [_c('TabBar',{attrs:{"tabs":_vm.tabs},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}})]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }